import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
// import { SavingsaccruedService } from "../shared/savingsaccrued.service";
import { SavingstransactionService } from "../../shared/savingstransaction.service";
import { PrintsavingstransactionlistserviceService } from "../../shared/print/printsavingstransactionlistservice.service";

@Component({
  selector: 'app-savingsaccruedlist',
  templateUrl: './savingsaccruedlist.component.html',
  styleUrls: ['./savingsaccruedlist.component.css']
})
export class SavingsaccruedlistComponent implements OnInit {

  private ToReceiptForm: boolean= false;

  displayedColumns: string[] = ['Date', 'Deposit No', 'Customer', 'Amount', 'New'];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor( //private savingsAccruedService: SavingsaccruedService,
     private savingstransactionService: SavingstransactionService,
     private printsavingstransactionlistserviceService: PrintsavingstransactionlistserviceService,
     private router: Router,
     private route: ActivatedRoute) { }

  ngOnInit() {
    // this.getSavingsAccruedList();
    this.getSavingsReceiptList();
    this.dataSource.paginator = this.paginator;
  }
  
  // getSavingsAccruedList() {
  //   this.savingsAccruedService.FetchSavingsAccruedList()
  //     .toPromise()
  //     .then(data => {
  //       this.dataSource.data = data;
  //       console.log(data);
  //     })
  //     .catch(err => { console.log(err) });
  // }

  getSavingsReceiptList() {
    let IsAccrued: boolean = true;
    this.savingstransactionService.FetchSavingsTransactionList(IsAccrued)
      .toPromise()
      .then(data => {
        this.dataSource = data;
      })
      .catch(err => { console.log(err) });
  }

  NewSavingsAccured() {
    this.router.navigate(['/savingsaccrued']);
  }

  // View (){
  // }

  EditSavingsAccured(savings: any) {
    this.router.navigate(['/savingsaccrued', savings.Id]);
  }

  PrintSavingsAccured(savings: any) {
    // this.paymentreceiptsService.GetSavingsCloseById(savings.Id);
    this.printsavingstransactionlistserviceService.GenerateReport(this.ToReceiptForm,savings.Id)
  }

}
